module.exports = __webpack_public_path__ + "static/media/foster-final.3f57af7b.jpg";